"use client"

interface IAppRoutes {
    rootRoute: () => string
}

/**
 * Returns an object containing root level application route strings based on the application context.
 *
 * @returns {IAppRoutes} An object with a `rootRoute` function that returns the root level application route string.
 */
const useAppRoutes = (): IAppRoutes => {
    const rootRoute = () => {
        if (typeof window !== "undefined") {
            // Client-side rendering, use window.location.origin to get the base URL
            return window.location.origin
        }

        // Fallback to environment variables for server-side rendering
        // This assumes you've set your environment variables correctly in Next.js
        return process.env.NEXT_PUBLIC_BASE_URL || "/"
    }

    return {
        rootRoute
    }
}

export default useAppRoutes
